import React, { useCallback, useState } from "react";
import { Drawer, Tooltip, Select, Checkbox, Divider } from "antd";
import {
  CloseIcon,
  IconInformationTemplateReport,
} from "../../../../../../asset";
import CustomDivider from "../../../../../../component/divider/CustomDivider";
import MSSOrderFromReport from "../../../../../../component/mss/order-from-report";
import MSSDepot from "../../../../../order/invoice/__components/mss-depot/MSSDepot";
import DDLDatePeriod from "../../../../../../component/dropdown-list/ddl-date-period";
import MSSDeliveryType from "../../../../../order/invoice/__components/mss-delivery-type";
import MSSCustomerReport from "../../../../../order/invoice/__components/mss-customer";
import MSSOrderStatusReport from "../../../../../order/invoice/__components/mss-order-status";

const DrawerFilterOrderReport = ({ onClose, open, appyFilter }) => {
  const [columnSelection, setColumnSelection] = useState({
    country: false,
    province: false,
    district: false,
    sub_district: false,
    urban_village: false,
    postal_code: false,
  });

  const onChangeCheckbox = useCallback((namespace, evt) => {
    setColumnSelection((prevsValue) => ({
      ...prevsValue,
      [namespace]: evt.target.checked,
    }));
  }, []);

  const btnApply = useCallback(() => {
    if (appyFilter) {
      appyFilter(columnSelection);
    }
  }, [appyFilter, columnSelection]);

  return (
    <Drawer
      title={null}
      onClose={onClose}
      open={open}
      closeIcon={null}
      width={"548px"}
    >
      <div className="flex justify-end">
        <img
          onClick={onClose}
          src={CloseIcon}
          style={{ height: "18px", width: "18px", cursor: "pointer" }}
          alt="icon-close"
        />
      </div>
      <div className="container-content-filter-drawer-report">
        <span className="span-title-drawer-report">Filter Report</span>
        <div className="flex flex-col gap-2 h-[1000px] overflow-x-auto">
          <div className="flex gap-2">
            <span className="span-label-filter-template-name">
              Filter Template
            </span>
            <Tooltip
              color="#C4C4C4"
              title={
                <span className="span-tooltip-title">
                  Type here directly to save a new template name or you can
                  select and replace existing one.
                </span>
              }
              placement="right"
            >
              <img src={IconInformationTemplateReport} alt="icon-information" />
            </Tooltip>
          </div>
          <div className="container-save-template">
            <Select
              placeholder="Select Filter Template"
              style={{ width: "80%" }}
              size="large"
            />
            <button className="btn-save-filter-template">Save Filter</button>
          </div>
          <CustomDivider name="Filter Data" />
          <div className="field-container">
            <span className="span-label-filter-template-name">Order From</span>
            <MSSOrderFromReport />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">Depot</span>
            <MSSDepot />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">Period Date</span>
            <DDLDatePeriod />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">
              Delivery Type
            </span>
            <MSSDeliveryType />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">Customer</span>
            <MSSCustomerReport />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">
              Order Status
            </span>
            <MSSOrderStatusReport />
          </div>
          <CustomDivider
            name={
              <div className="flex gap-2">
                <span>Customize Optional Columns</span>
                <Tooltip
                  color="#C4C4C4"
                  title={
                    <span className="span-tooltip-title">
                      Customize your table with optional columns. All primary
                      columns has been added as default.
                    </span>
                  }
                  placement="top"
                >
                  <img
                    src={IconInformationTemplateReport}
                    alt="icon-information"
                  />
                </Tooltip>
              </div>
            }
          />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("country", evt);
            }}
          >
            Country
          </Checkbox>
          <Divider />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("province", evt);
            }}
          >
            Province
          </Checkbox>
          <Divider />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("district", evt);
            }}
          >
            District
          </Checkbox>
          <Divider />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("sub_district", evt);
            }}
          >
            Sub District
          </Checkbox>
          <Divider />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("urban_village", evt);
            }}
          >
            Urban Village
          </Checkbox>
          <Divider />
          <Checkbox
            onChange={(evt) => {
              onChangeCheckbox("postal_code", evt);
            }}
          >
            Postal Code
          </Checkbox>
          <Divider />
        </div>
        <div className="flex justify-end gap-4 mt-5">
          <button
            className="border-[2px] border-red-100 w-[140px] h-[44px] rounded-md font-sans text-red-100 font-semibold text-xl"
            onClick={onClose}
          >
            Reset
          </button>
          <button
            className="bg-red-100 w-[140px] h-[44px] rounded-md font-sans text-white-100 font-semibold text-xl"
            onClick={btnApply}
          >
            Apply
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default DrawerFilterOrderReport;
